<template>
  <div>
    <section-title :has-line="true" title="Historial de Hallazgos UMESR" />
    <div class="bg-secondary-3 rounded  pt-2 pb-3 px-4">
      <div class="row student bg-white p-3 rounded mb-2">
        <div class="col-6 col-md-3 mb-3">
          <div class="student__label">
            <em class="student__label_icon fas fa-address-book text-orange" />
            SIE:
          </div>
          <span class="student__info">
            {{ student.studentSieId }}
          </span>
        </div>
        <div class="col-12  col-md-3 mb-3">
          <div class="student__label">
            <em class="student__label_icon fas fa-address-book text-orange" />
            Nombre del Estudiante:
          </div>
          <span class="student__info">
            {{ student.studentFullName }}
          </span>
        </div>
        <div class="col-12  col-md-3 mb-3">
          <div class="student__label">
            <em class="student__label_icon fas fa-ballot-check text-orange" />
            Impedimento:
          </div>
          <span class="student__info">
            {{ student.impedimentName }}
          </span>
        </div>
      </div>
      <div class="row student p-3 rounded mb-2">
        <div class="col-12  col-md-3 mb-3">
          <div class="student__label">
            Tipo de Servicio:
          </div>
          <span class="student__info">
            {{ student.disciplineTypeName }}
          </span>
        </div>
        <div class="col-12  col-md-3 mb-3">
          <div class="student__label">
            Proveedor:
          </div>
          <span class="student__info">
            {{ student.companyName }}
          </span>
        </div>
        <div class="col-12  col-md-3 mb-3">
          <div class="student__label">
            Referido:
          </div>
          <span class="student__info">
            {{ student.referralNumber }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';

export default {
  components: {
    SectionTitle,
  },
  props: {
    student: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
<style lang="scss" scoped>
.student {
  &__label {
    font-weight: normal;
    font-size: 14px;
    color: #727272;

    &_icon {
      margin-left: -0.9rem;
    }
  }

  &__info {
    font-weight: normal;
    font-size: 16px;
    color: #11291b;
  }
}
</style>
